import React, { useRef } from "react";
import { eventService } from "../lib/api/event";
import { axiosInstance } from '../lib/api/index';

const DoctorRegPrint: React.FC = () => {
  const handleDownload = () => {
    // This triggers the browser's default behavior for the endpoint
    window.open("/api/certificate/sample", "_blank");
};
  return (
    <div className="container py-4">
      <div className="text-center mb-3">
        <button className="btn btn-primary" onClick={handleDownload}>
          <i className="bi bi-download me-2"></i>
          Download Event Certificate
        </button>
      </div>
    </div>
  );
};

export default DoctorRegPrint;
